<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-text-field
        v-model="innerValue"
        :prepend-icon="prependIcon"
        :type="type"
        :error-messages="errors"
        :readonly="readonly"
        :clearable="!readonly"
        :single-line="singleLine"
        :hide-details="hideDetails"
        :persistent-hint="persistentHint"
        :dense="dense"
        :label="label || $t('Серия и номер документа')"
        :title="$t('Формат ввода СССС НННННН')"
        :hint="hint || $t('Формат ввода СССС НННННН')"
        @change="documentPersonIdentityChanged"
        @keyup="documentPersonIdentityKeyup"
        @contextmenu.prevent>
      <template
          v-if="required"
          v-slot:prepend-inner>
        <v-icon
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-text-field>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      singleLine: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: Boolean,
        default: false
      },
      persistentHint: {
        type: Boolean,
        default: false
      },
      solo: {
        type: Boolean,
        default: false
      },
      hint: {
        type: String,
        default: ''
      },
      dense: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            const identity = newVal
              ? `${newVal.substring(0, 4)} ${newVal.substring(4)}`
              : null
            if (this.innerValue !== identity) {
              this.innerValue = identity
            }
          }
        }
      }
      // innerValue (val) {
      //   this.$emit('input', (val || '').replace(/\s*/g, ''))
      // }
    },
    methods: {
      documentPersonIdentityKeyup: function () {
        this.documentPersonIdentityChanged(this.innerValue)
      },
      documentPersonIdentityChanged: function (value) {
        let formattedValue = (value || '').replace(/[^0-9]*/g, '')
        if (value && value.length > 4) {
          formattedValue = `${formattedValue.substring(0, 4)} ${formattedValue.substring(4, 10)}`
        }
        this.innerValue = formattedValue
        this.change(formattedValue.trim())
      },
      change: function (value) {
        value = (value || '').replace(/\s*/g, '')
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>
